import getRequest from '../../../getRequest';

/**
 * Get all users from PRISM db.
 *
 * @returns {object}
 */
const getUsersCount = () => {
  const endpoint = '/users-management/get-users-count';

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get Users Count')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default getUsersCount;
